// Landing V2 feature flag (frontend).
//
// Small, single-purpose flag reader that gates the production
// Landing.jsx between V1 (current, default) and V2 (the approved
// six-section Features composition extracted into
// frontend/src/components/landing/*).
//
// Off by default: V1 remains the default production experience.
// V2 is opt-in for QA via a safe preview mechanism.
//
// Sources (first non-empty wins):
//   1. `?leviLandingV2=1` URL query param (safe per-request QA preview,
//      no rebuild, no persistent state)
//   2. window.__leviLandingV2Override  (JS console QA toggle)
//   3. process.env.REACT_APP_LEVI_LANDING_V2_ENABLED  (env-level opt-in)
//   4. default: false
//
// "1", "true", "on", "yes" (case-insensitive) → true; else false.

const _truthy = (v) => {
  if (v === true) return true;
  if (v == null) return false;
  const s = String(v).trim().toLowerCase();
  return s === "1" || s === "true" || s === "on" || s === "yes";
};

export function isLandingV2Enabled() {
  try {
    if (typeof window !== "undefined" && window.location && window.location.search) {
      const params = new URLSearchParams(window.location.search);
      const q = params.get("leviLandingV2");
      if (q != null) return _truthy(q);
    }
  } catch { /* noop */ }
  try {
    if (typeof window !== "undefined"
        && window.__leviLandingV2Override != null) {
      return _truthy(window.__leviLandingV2Override);
    }
  } catch { /* noop */ }
  try {
    return _truthy(process.env.REACT_APP_LEVI_LANDING_V2_ENABLED);
  } catch { /* noop */ }
  return false;
}
